<div class="floori-expansion-panel" [class.expanded]="isExpanded()">
    <div
        class="expansion-header"
        (click)="toggle()"
        (keydown.enter)="toggle()"
        (keydown.space)="toggle()"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="isExpanded()"
        [attr.aria-label]="title() || 'Expandable section'">
        <div class="header-content">
            @if (title()) {
                <h3 class="title">{{ title() }}</h3>
            }
            @if (subtitle()) {
                <p class="subtitle">{{ subtitle() }}</p>
            }
            <ng-content select="[headerContent]"></ng-content>
        </div>
        <div class="expansion-icon-wrapper">
            <floori-icon
                name="fl_chevron_down_o"
                class="expansion-icon"
                [class.expanded]="isExpanded()" />
        </div>
    </div>
    <div class="expansion-content" [class.expanded]="isExpanded()">
        <div class="content-wrapper">
            <ng-content></ng-content>
        </div>
    </div>
</div>
